import Container from "@/components/ui/container";

export default function RoadmapPage() {
	return (
		<Container className="py-12">
			<h1 className="text-3xl font-bold text-gray-900">Roadmap</h1>
			<p className="mt-4 text-gray-600">Roadmap page content coming soon...</p>
		</Container>
	);
}
